import getData from '../../dataFetcher/getDataFetcher';

const baseUrl = process.env.REACT_APP_BACKEND_URL;

export const getActivityLogs = async ({token, current_page = 1, page_size = 10}) => {
  try {
	let apiUrl = `${baseUrl}activity/lists`;
	// Add pagination query params
    const queryParams = new URLSearchParams({
		current_page,
		page_size,
	}).toString();
	apiUrl += `?${queryParams}`;
	const response = await getData(apiUrl, null, token);
	return response;
  } catch (error) {
	throw error;
  }
};
